var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconvalid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9571 2.40061C13.6945 2.40773 13.4453 2.51689 13.261 2.70435C13.2191 2.74627 12.6211 3.32527 11.8373 4.07116C11.0534 4.81705 10.0402 5.77967 9.0277 6.7416C8.01525 7.70354 7.00359 8.66447 6.21815 9.41205C5.80051 9.8099 5.69214 9.91196 5.43981 10.1524L1.68119 6.90627C1.47712 6.72988 1.21135 6.64129 0.94242 6.66107C0.673493 6.68006 0.423539 6.80582 0.247149 7.0099C0.0707618 7.21397 -0.01704 7.47974 0.00274334 7.74867C0.0225267 8.0176 0.148283 8.26755 0.352363 8.44394L4.80715 12.2913C5.20897 12.6393 5.81169 12.6171 6.18662 12.2406C6.22854 12.1987 6.82653 11.6197 7.61037 10.8738C8.39423 10.1279 9.40747 9.17165 10.4199 8.20986C11.4324 7.24807 12.444 6.28067 13.2295 5.53314C14.0149 4.78567 14.5306 4.30159 14.6912 4.14102C14.9918 3.85073 15.0827 3.40462 14.9206 3.0194C14.7577 2.63421 14.3756 2.3882 13.9572 2.40086L13.9571 2.40061Z",
    fill: "#29B974"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconvalid);
export default __webpack_public_path__ + "static/media/icon.valid.dd4cb6a7ac63ff4d76fe653446275875.svg";
export { ForwardRef as ReactComponent };